document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.water-sub-card').forEach(function (card) {
    const jsonEl = card.querySelector('.water-sub-card__json');
    if (!jsonEl) return;

    const data = JSON.parse(jsonEl.textContent);
    const packsWrap = card.querySelector('.water-sub-card__packs');
    const packButtons = card.querySelectorAll('.water-sub-card__pack');
    const typeTabs = card.querySelectorAll('.water-sub-card__type-tab');
    const planSelect = card.querySelector('.water-sub-card__plan-select');
    const subscribeWrap = card.querySelector('.water-sub-card__subscribe-wrap');
    const cta = card.querySelector('.water-sub-card__cta');
    const ctaText = card.querySelector('.water-sub-card__cta-text');
    const oneTimePriceEl = card.querySelector('.water-sub-card__one-time-price');
    const subscribePriceEl = card.querySelector('.water-sub-card__subscribe-price');
    const discountBadgeEl = card.querySelector('.water-sub-card__discount-badge');
    const purchaseInputs = card.querySelectorAll('input[name^="purchase_type_"]');

    let selectedVariantId = Number(card.dataset.selectedVariantId);
    let activeGroup = card.dataset.activeGroup || 'cases';

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, data.moneyFormat);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function getSelectedVariant() {
      return data.variants.find(function (v) {
        return Number(v.id) === Number(selectedVariantId);
      });
    }

    function getPurchaseType() {
      const checked = card.querySelector('input[name^="purchase_type_"]:checked');
      return checked ? checked.value : 'onetime';
    }

    function setDefaultPurchaseType(hasPlans) {
      const subscribeRadio = card.querySelector('input[value="subscribe"]');
      const oneTimeRadio = card.querySelector('input[value="onetime"]');

      if (hasPlans && subscribeRadio) {
        subscribeRadio.checked = true;
      } else if (oneTimeRadio) {
        oneTimeRadio.checked = true;
      }
    }

    function getVisiblePackButtons() {
      return Array.from(packButtons).filter(function (button) {
        return !button.classList.contains('is-hidden');
      });
    }

    function updatePackColumns() {
      if (!packsWrap) return;
      const visibleCount = getVisiblePackButtons().length || 1;
      packsWrap.style.setProperty('--water-pack-columns', Math.min(visibleCount, 4));
    }

    function rebuildPlanDropdown(variant) {
      if (!planSelect || !subscribeWrap) return;

      planSelect.innerHTML = '';

      const hasPlans = !!(variant && variant.plans && variant.plans.length);

      if (!hasPlans) {
        subscribeWrap.classList.add('is-hidden');
        setDefaultPurchaseType(false);
        return;
      }

      subscribeWrap.classList.remove('is-hidden');

      variant.plans.forEach(function (plan) {
        const option = document.createElement('option');
        option.value = plan.id;
        option.textContent = plan.name;
        option.dataset.price = plan.price;
        option.dataset.discount = plan.discountPercent || 0;
        planSelect.appendChild(option);
      });

      setDefaultPurchaseType(true);
    }

    function updateVisuals() {
      const variant = getSelectedVariant();
      if (!variant) return;

      const hasPlans = !!(variant.plans && variant.plans.length);
      const selectedOption =
        hasPlans && planSelect && planSelect.options.length
          ? planSelect.options[planSelect.selectedIndex]
          : null;

      const oneTimePrice = Number(variant.price);
      const subPrice = selectedOption
        ? Number(selectedOption.dataset.price)
        : hasPlans
          ? Number(variant.plans[0].price)
          : oneTimePrice;

      const subDiscount = selectedOption
        ? Number(selectedOption.dataset.discount || 0)
        : hasPlans
          ? Number(variant.plans[0].discountPercent || 0)
          : 0;

      if (oneTimePriceEl) {
        oneTimePriceEl.textContent = formatMoney(oneTimePrice);
      }

      if (subscribePriceEl) {
        subscribePriceEl.textContent = formatMoney(subPrice);
      }

      if (discountBadgeEl) {
        if (hasPlans && subDiscount > 0) {
          discountBadgeEl.textContent = subDiscount + '% OFF';
          discountBadgeEl.classList.remove('is-hidden');
        } else {
          discountBadgeEl.textContent = '';
          discountBadgeEl.classList.add('is-hidden');
        }
      }

      const purchaseType = getPurchaseType();
      const nextText =
        purchaseType === 'subscribe' && hasPlans
          ? 'SUBSCRIBE NOW • ' + formatMoney(subPrice)
          : 'ADD TO CART • ' + formatMoney(oneTimePrice);

      if (ctaText) {
        ctaText.textContent = nextText;
      } else if (cta) {
        cta.textContent = nextText;
      }
    }

    function setActivePack(button) {
      if (!button) return;

      packButtons.forEach(function (btn) {
        btn.classList.remove('is-active');
      });

      button.classList.add('is-active');
      selectedVariantId = Number(button.dataset.variantId);
      card.dataset.selectedVariantId = selectedVariantId;

      const variant = getSelectedVariant();
      rebuildPlanDropdown(variant);
      updateVisuals();
    }

    function setGroup(group, forceFirstInGroup) {
      activeGroup = group;
      card.dataset.activeGroup = group;

      typeTabs.forEach(function (tab) {
        tab.classList.toggle('is-active', tab.dataset.groupTarget === group);
      });

      packButtons.forEach(function (button) {
        button.classList.toggle('is-hidden', button.dataset.group !== group);
      });

      updatePackColumns();

      let targetButton = Array.from(packButtons).find(function (button) {
        return button.dataset.group === group && Number(button.dataset.variantId) === Number(selectedVariantId);
      });

      if (!targetButton || forceFirstInGroup) {
        targetButton = Array.from(packButtons).find(function (button) {
          return button.dataset.group === group;
        });
      }

      setActivePack(targetButton);
    }

    packButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.classList.contains('is-hidden')) return;

        if (typeTabs.length && button.dataset.group) {
          activeGroup = button.dataset.group;
          card.dataset.activeGroup = activeGroup;

          typeTabs.forEach(function (tab) {
            tab.classList.toggle('is-active', tab.dataset.groupTarget === activeGroup);
          });
        }

        setActivePack(button);
      });
    });

    typeTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const group = tab.dataset.groupTarget;
        if (!group) return;
        setGroup(group, true);
      });
    });

    purchaseInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        updateVisuals();
      });
    });

    if (planSelect) {
      planSelect.addEventListener('change', function () {
        const subscribeRadio = card.querySelector('input[value="subscribe"]');
        if (subscribeRadio) subscribeRadio.checked = true;
        updateVisuals();
      });
    }

    if (cta) {
      cta.addEventListener('click', function () {
        const variant = getSelectedVariant();
        if (!variant) return;

        const payloadItem = {
          id: Number(variant.id),
          quantity: 1
        };

        if (getPurchaseType() === 'subscribe' && variant.plans && variant.plans.length && planSelect) {
          payloadItem.selling_plan = Number(planSelect.value);
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: [payloadItem] })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(function () {
            window.location.href = '/cart';
          })
          .catch(function (error) {
            console.error(error);
            alert('Product add nahi hua, please dubara try karo.');
          });
      });
    }

    if (typeTabs.length) {
      setGroup(activeGroup, false);
    } else {
      updatePackColumns();
      rebuildPlanDropdown(getSelectedVariant());
      updateVisuals();
    }
  });
});